import {
  EQUIPMENT_SPECIFIC_CREATE,
  EQUIPMENT_SPECIFIC_DELETE,
  EQUIPMENT_SPECIFIC_EDIT,
  EQUIPMENT_SPECIFIC_EDIT_SINGLE,
  EQUIPMENT_SPECIFIC_FETCH,
} from '../action-types/equipment-specific-types';

const initialState = {
  loading: false,
  equipment_specific_list: [],
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case EQUIPMENT_SPECIFIC_FETCH.REQUEST:
    case EQUIPMENT_SPECIFIC_CREATE.REQUEST:
    case EQUIPMENT_SPECIFIC_EDIT.REQUEST:
    case EQUIPMENT_SPECIFIC_DELETE.REQUEST:
    case EQUIPMENT_SPECIFIC_EDIT_SINGLE.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EQUIPMENT_SPECIFIC_FETCH.SUCCESS:
      return {
        ...state,
        equipment_specific_list: action.payload,
        loading: false,
      };
    case EQUIPMENT_SPECIFIC_FETCH.REJECTED:
    case EQUIPMENT_SPECIFIC_CREATE.REJECTED:
    case EQUIPMENT_SPECIFIC_EDIT.REJECTED:
    case EQUIPMENT_SPECIFIC_DELETE.REJECTED:
    case EQUIPMENT_SPECIFIC_EDIT_SINGLE.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
